import React from 'react';
import { FadeInView } from '../ui/FadeInView';
export function TomosSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#F5F0E8] text-center relative overflow-hidden" data-id="element-390">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-391">
        <FadeInView data-id="element-392">
          <h2 className="text-4xl md:text-6xl font-bold text-[#1B4332] mb-6 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-393">
            🎁 MÁS LOS 3 BONOS ESTRATÉGICOS
          </h2>

          <p className="text-xl font-medium text-[#2D5016] mb-12 bg-[#2D5016]/10 inline-block px-8 py-2 rounded-full tracking-widest uppercase" data-id="element-394">
            Incluidos en todas las ofertas — sin coste extra
          </p>

          {/* 3 Bonuses Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-395">
            {/* Bonus 1 */}
            <div className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-396">
              <h3 className="text-sm font-medium text-[#D4A853] mb-2 tracking-widest uppercase" data-id="element-397">
                🎁 BONO 1
              </h3>
              <h4 className="text-2xl font-bold text-[#1B4332] mb-4 leading-tight" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-398">
                Plan Semanal Completo
              </h4>
              <p className="text-base text-[#2D5016]/80 mb-6 leading-relaxed" data-id="element-399">
                Tu semana de alimentación resuelta de domingo a domingo.
                Desayuno, comida, merienda y cena. Sin improvisar, sin abrir la
                nevera sin saber qué hacer, sin acabar pidiendo Glovo por
                cansancio.
              </p>
              <div className="bg-[#F5F0E8] p-4 rounded-2xl border border-[#D4A853]/10 shadow-sm" data-id="element-400">
                <p className="text-sm text-[#1B4332]/40 line-through mb-1" data-id="element-401">
                  Valor: 9,00€
                </p>
                <p className="text-xl font-bold text-[#2D5016]" data-id="element-402">HOY: GRATIS</p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-403">
              <h3 className="text-sm font-medium text-[#D4A853] mb-2 tracking-widest uppercase" data-id="element-404">
                🎁 BONO 2
              </h3>
              <h4 className="text-2xl font-bold text-[#1B4332] mb-4 leading-tight" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-405">
                Guía de Cocción para tu Air Fryer
              </h4>
              <p className="text-base text-[#2D5016]/80 mb-6 leading-relaxed" data-id="element-406">
                Temperaturas exactas, tiempos precisos y técnicas para cada tipo
                de alimento. Pollo, pescado, verduras, patatas, carnes. Nunca
                más carne seca ni verduras quemadas.
              </p>
              <div className="bg-[#F5F0E8] p-4 rounded-2xl border border-[#D4A853]/10 shadow-sm" data-id="element-407">
                <p className="text-sm text-[#1B4332]/40 line-through mb-1" data-id="element-408">
                  Valor: 7,00€
                </p>
                <p className="text-xl font-bold text-[#2D5016]" data-id="element-409">HOY: GRATIS</p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-410">
              <h3 className="text-sm font-medium text-[#D4A853] mb-2 tracking-widest uppercase" data-id="element-411">
                🎁 BONO 3
              </h3>
              <h4 className="text-2xl font-bold text-[#1B4332] mb-4 leading-tight" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-412">
                Lista de la Compra Mensual
              </h4>
              <p className="text-base text-[#2D5016]/80 mb-6 leading-relaxed" data-id="element-413">
                La lista exacta de lo que necesitas cada semana para seguir el
                sistema. Organizada por secciones del supermercado. Entra al
                Mercadona con un plan y sal en 20 minutos.
              </p>
              <div className="bg-[#F5F0E8] p-4 rounded-2xl border border-[#D4A853]/10 shadow-sm" data-id="element-414">
                <p className="text-sm text-[#1B4332]/40 line-through mb-1" data-id="element-415">
                  Valor: 6,00€
                </p>
                <p className="text-xl font-bold text-[#2D5016]" data-id="element-416">HOY: GRATIS</p>
              </div>
            </div>
          </div>

          {/* Bonus Value Summary Table */}
          <div className="bg-[#FAF7F2] rounded-2xl p-8 border border-[#D4A853]/20 shadow-sm max-w-2xl mx-auto overflow-x-auto" data-id="element-417">
            <table className="w-full text-left" data-id="element-418">
              <tbody className="divide-y divide-[#D4A853]/10" data-id="element-419">
                <tr data-id="element-420">
                  <td className="py-3 font-medium text-[#1B4332]" data-id="element-421">
                    Plan Semanal Completo
                  </td>
                  <td className="py-3 text-right font-bold text-[#2D5016]" data-id="element-422">
                    9,00€
                  </td>
                </tr>
                <tr data-id="element-423">
                  <td className="py-3 font-medium text-[#1B4332]" data-id="element-424">
                    Guía de Cocción Air Fryer
                  </td>
                  <td className="py-3 text-right font-bold text-[#2D5016]" data-id="element-425">
                    7,00€
                  </td>
                </tr>
                <tr data-id="element-426">
                  <td className="py-3 font-medium text-[#1B4332]" data-id="element-427">
                    Lista de la Compra Mensual
                  </td>
                  <td className="py-3 text-right font-bold text-[#2D5016]" data-id="element-428">
                    6,00€
                  </td>
                </tr>
                <tr className="border-t-2 border-[#D4A853]/30" data-id="element-429">
                  <td className="py-3 font-bold text-[#1B4332] text-lg" data-id="element-430">
                    TOTAL BONOS
                  </td>
                  <td className="py-3 text-right font-bold text-[#2D5016] text-lg" data-id="element-431">
                    22,00€
                  </td>
                </tr>
                <tr data-id="element-432">
                  <td className="py-3 font-bold text-[#D4A853] text-xl" data-id="element-433">
                    Precio hoy
                  </td>
                  <td className="py-3 text-right font-bold text-[#D4A853] text-2xl" data-id="element-434">
                    GRATIS
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </FadeInView>
      </div>
    </section>;
}